import React from "react";
import { Input } from "antd";
import styles from "../styles.module.scss";
import { IconEye, IconEyeClosed } from "@tabler/icons-react";

const CustomInput = ({
  title,
  required = false,
  placeholder = "-",
  value,
  onChange,
  type = "text",
  prefix,
  suffix,
  isPassword = false,
  disabled = false,
  allowClear = true,
  style,
}) => {
  const InputComponent = isPassword ? Input.Password : Input;

  return (
    <div className="d-flex flex-column gap-1">
      {title && (
        <div className={styles.title}>
          {required && <span>*</span>}
          {title}
        </div>
      )}

      <InputComponent
        allowClear={allowClear}
        type={type}
        placeholder={placeholder}
        className={styles.input}
        value={value}
        onChange={onChange}
        prefix={prefix}
        suffix={suffix}
        disabled={disabled}
        style={{ ...style }}
        iconRender={(visible) =>
          visible ? (
            <IconEye color="#888" size={20} />
          ) : (
            <IconEyeClosed color="#888" size={20} />
          )
        }
      />
    </div>
  );
};

export default CustomInput;
